<template>
    <div class="app side-nav-dark" id="app" :class="{'is-collapsed': isCollapsed}">
        <div class="layout">
            <side-nav>
                <side-nav-logo/>
                <side-nav-menu :nav-items="nav"/>
            </side-nav>
            <div class="page-container">
                <Header></Header>
                <div class="main-content">
                    <router-view/>
                </div>
                <Footer></Footer>
            </div><!-- end .page-container -->
        </div><!-- end .layout -->
    </div><!-- end #app -->
</template>

<script>
    import nav from "../config/_nav";
    import SideNav from "../components/SideNav/SideNav";
    import Footer from "../components/Footer";
    import Header from "../components/Header/Header";
    import SideNavMenu from "../components/SideNav/SideNavMenu";
    import SideNavLogo from "../components/SideNav/SideNavLogo";
    export default {
        components: { SideNavLogo, SideNavMenu, Header, Footer, SideNav },
        data: function () {
            return {
                nav: nav.items
            };
        },
        computed: {
            isCollapsed(){
                return this.$store.getters.isCollapsed;
            }
        }
    };
</script>
